export default __webpack_public_path__ + "static/media/elo.745421df.svg";